import { h } from '@stencil/core';
import type { GuidedV2Emitters } from '../../models/eventNames';
import { MegaBannerGenAI } from './mega-banner-genai';

export interface IGuidedBannerGenai{
    /**
   * Text to show in the banner, the bolded line
   * @type {string}
   */
    text: string;
    /**
   * @typedef {string} description
   * @description A descriptive text that provides more detailed information about an item or entity. The not bolded line.
   */
  description: string;
  /**
   * Represents the text label displayed on a button.
   * This string is typically used to inform the user of the button's action.
   * @type {string}
  */
  buttonText: string;
  /**
   * The URL hyperlink reference.
   *
   * Represents a reference to a web resource, typically a URL.
   * Used to specify the target location for hyperlinks.
   *
   * @type {string}
  */
  href: string;
  /**
   * Specifies where to open the linked document.
   * Common values:
   * - `_self`: Opens in the same frame.
   * - `_blank`: Opens in a new tab or window.
   * - `_parent`: Opens in the parent frame.
   * - `_top`: Opens in the full body of the window.
   * @type {string}
  */
  target: string;
  /**
   * Guided Search event emitters
   * @type {GuidedV2Emitters}
  */
  eventEmitters: GuidedV2Emitters;
  /**
   * Guided Search current term
   * @type {string}
  */
  searchTerm: string;

  /**
   * Application type
   * @type {string}
  */
  brand?: string;
}

export const GuidedBannerGenai = (
  props: IGuidedBannerGenai,
) => {
    const { text, description, buttonText, eventEmitters, brand } = props;
    const areTermsAndConditionsAccepted = sessionStorage.getItem('conversational_terms_and_conditions');

    // Remove banner for accepted terms and conditions
    if (areTermsAndConditionsAccepted) return;

    return (
      <div class="guided-v2-section__footer">
        <MegaBannerGenAI
          text={text}
          description={description}
          buttonText={buttonText}
          eventEmitters={eventEmitters}
          href={props.href}
          target={props.target}
          searchTerm={props.searchTerm}
          brand={brand}
        />
      </div>
    );
};
